// src/pages/SingleListingGenerator/components/ExistingListingForm.js
import React from 'react';
import { FaTimes } from 'react-icons/fa';
import styles from '../SingleListingGeneratorPage.module.css';

const ExistingListingForm = ({ existingInput, handleExistingInputChange, isLoading, isAsinDataFetched, isExpanded, asinProductData, onRemoveAsinData, invalidFields = new Set(), asinBulletsLocked = false, asinDescriptionLocked = false }) => {
  const bulletFieldsLocked = isAsinDataFetched && asinBulletsLocked;
  const descriptionFieldLocked = isAsinDataFetched && asinDescriptionLocked;
  return (
    <div className={styles.existingListingSection}>
      <div className={styles.sectionContent}>
        {asinProductData && (
          <div className={styles.asinReferenceCard}>
            <div className={styles.asinReferenceCardInner}>
              {asinProductData.firstImage && (
                <img 
                  src={asinProductData.firstImage} 
                  alt="Product" 
                  className={styles.asinReferenceImage}
                />
              )}
              <div className={styles.asinReferenceContent}>
                <p className={styles.asinReferenceTitle}>
                  {asinProductData.title || 'Product Title'}
                </p>
                {asinProductData.asin && (
                  <span className={styles.asinReferenceTag}>
                    {asinProductData.asin}
                  </span>
                )}
              </div>
              {onRemoveAsinData && (
                <button
                  type="button"
                  className={styles.asinReferenceClose}
                  onClick={onRemoveAsinData}
                  title="Remove ASIN data"
                >
                  <FaTimes />
                </button>
              )}
            </div>
          </div>
        )}
        
        <div className={styles.formGroup} style={{ marginBottom: '32px', marginTop: '0'}}>
          <label htmlFor="existingTitleInput" className={styles.existingListingLabel}>
            Item Name<span className={styles.requiredAsterisk}>*</span>
            {invalidFields.has('title') && <span className={styles.requiredLabel}>required*</span>}
          </label>
          <input
            id="existingTitleInput"
            name="title"
            type="text"
            className={styles.existingListingInput}
            placeholder="Your current title goes here"
            value={existingInput.title}
            onChange={handleExistingInputChange}
            required
            disabled={isLoading || isAsinDataFetched}
            style={{ opacity: isAsinDataFetched ? 0.6 : 1 }}
          />
        </div>
        
        <div className={styles.formGroup} style={{ marginBottom: '32px'}}>
          <label className={styles.existingListingLabel}>
            Bullet Points{bulletFieldsLocked && <span className={styles.requiredAsterisk}>*</span>}
            {[0, 1, 2, 3, 4].some(i => invalidFields.has(`bullet-${i}`)) && <span className={styles.requiredLabel}>required*</span>}
          </label>
          {existingInput.bullets.map((bullet, index) => (
            <input
              key={index}
              id={`existingBulletInput-${index}`}
              name={`bullet-${index}`}
              type="text"
              className={styles.existingListingInput}
              style={{
                marginBottom: index < existingInput.bullets.length - 1 ? '12px' : '0',
                opacity: bulletFieldsLocked ? 0.6 : 1
              }}
              placeholder={`${index + 1}. Your current bullet point`}
              value={bullet}
              onChange={handleExistingInputChange}
              disabled={isLoading || bulletFieldsLocked}
            />
          ))}
        </div>
        
        <div className={styles.formGroup}>
          <label htmlFor="existingDescriptionInput" className={styles.existingListingLabel}>
            Brief Description{descriptionFieldLocked && <span className={styles.requiredAsterisk}>*</span>}
            {invalidFields.has('description') && <span className={styles.requiredLabel}>required*</span>}
          </label>
          <textarea
            id="existingDescriptionInput"
            name="description"
            className={styles.existingListingTextarea}
            placeholder="Your current description goes here"
            value={existingInput.description}
            onChange={handleExistingInputChange}
            disabled={isLoading || descriptionFieldLocked}
            style={{ opacity: descriptionFieldLocked ? 0.6 : 1 }}
            rows="7"
            required
          ></textarea>
        </div>
      </div>
    </div>
  );
};

export default ExistingListingForm;